// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.doubleCode .el-dialog {\r\n  margin-top: 0px !important;\r\n  position: absolute;\r\n  left: 0px;\r\n  top: 0px;\n}\n.doubleCode .el-dialog__header {\r\n  display: none !important;\n}\n.doubleCode .el-dialog__body {\r\n  padding: 0px !important;\r\n  max-height: 40vh;\r\n  overflow: auto;\n}\n.doubleCode .tool-btn{\r\n    text-align: center;\n}\n.doubleCode .custom-checkbox {\r\n  width: 100%;\r\n  margin-top: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
